<template>
	<div class="layerPop" id="PopChkNeed" v-if="isVisible">
		<div class="popWrap">
			<div class="popBox popType2">
				<div class="popHead">
					<p class="popTit">필요사항 확인하기</p>
				</div>

				<div class="popCon">
					<div class="memoView lh28 hAuto">
						01&nbsp;&nbsp;계약자명, 피보험자명<br>
						02&nbsp;&nbsp;선박명, 출항 예정일자<br>
						03&nbsp;&nbsp;출항지명, 도착지명, 환적 시 환적항, 출발지 및 최종 도착지<br>
						04&nbsp;&nbsp;피보험 화물의 수량, 품명 및 명세<br>
						05&nbsp;&nbsp;송장금액 및 보험가입금액<br>
						06&nbsp;&nbsp;보험 가입 조건<br>
						07&nbsp;&nbsp;화폐단위 및 사고발생 시 보험금 지급내역<br>
						08&nbsp;&nbsp;참고번호 (신용장번호, 상업송장번호 등)<br>
						09&nbsp;&nbsp;기타 중요사항
					</div>
				</div>
				<button type="button" class="popClose" @click="close(this);"><span class="hide">닫기</span></button>
			</div>
		</div>
	</div>	
</template>

<script setup>
import {ref , defineEmits,defineExpose} from 'vue'

const isVisible = ref(false);

const emits = defineEmits(['update:data' ,'close']);

const open = () => {
 	isVisible.value =true;
}

const close = () => {
	isVisible.value =false;
	emits('close');
}
defineExpose({open , close})


</script>